import { ACTION_TYPE } from './action';

const mailMagazineDetail = (state = {}, action) => {
  switch (action.type) {
    case ACTION_TYPE.INIT_MAIL_MAGAZINE_DETAIL_SUCCESS:
      return {
        ...state,
        data: action.data,
      };
    case ACTION_TYPE.CALL_API_UPDATE_MAIL_MAGAZINE_DETAIL:
      return {
        ...state,
        isUpdateSuccess: false,
      };
    case ACTION_TYPE.UPDATE_MAIL_MAGAZINE_DETAIL_SUCCESS:
      return {
        ...state,
        isUpdateSuccess: true,
        detailId: action.id,
      };
    case ACTION_TYPE.CALL_API_SEND_MAIL_MAGAZINE:
      return {
        ...state,
        isSendMailSuccess: false,
      };
    case ACTION_TYPE.SEND_MAIL_MAGAZINE_SUCCESS:
      return {
        ...state,
        isSendMailSuccess: true,
      };
    case ACTION_TYPE.CALL_API_CONFIRM_REQUEST:
      return {
        ...state,
        isConfirmRequestSuccess: false,
      };
    case ACTION_TYPE.CONFIRM_REQUEST_SUCCESS:
      return {
        ...state,
        isConfirmRequestSuccess: true,
      };
    default:
      return state;
  }
};

export default mailMagazineDetail;
